import { ValidHttpMethods } from './valid-http-methods.enum';

export interface IApiCallDefinition {
  method: ValidHttpMethods;
  path: RegExp;
}
